var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 14.97H13.85V16.47H21.35V14.97Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 17.97H13.85V19.47H21.35V17.97Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 20.97H13.85V22.47H21.35V20.97Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59998 5.21997V20.97C2.59998 21.8 3.26998 22.47 4.09998 22.47H12.35V20.97H4.09998V5.21997H6.34998V7.46997H15.35V5.21997H17.6V13.4H19.1V5.21997C19.1 4.38997 18.43 3.71997 17.6 3.71997H15.35V2.96997C15.35 2.13997 14.68 1.46997 13.85 1.46997H7.84998C7.01998 1.46997 6.34998 2.13997 6.34998 2.96997V3.71997H4.09998C3.26998 3.71997 2.59998 4.38997 2.59998 5.21997ZM7.84998 2.96997H13.85V5.96997H7.84998V2.96997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentLines);
export default __webpack_public_path__ + "static/media/ic-document-lines.3716385bbd5549610eb098d7d283d852.svg";
export { ForwardRef as ReactComponent };